var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIbm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 576,
    height: 576,
    viewBox: "0 0 576 576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 576,
    height: 576
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 128.0382,
    y: 343.3538,
    width: 62.1979,
    height: 8.0777
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 128.0382,
    y: 326.3908,
    width: 62.1979,
    height: 8.0776
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145.8092,
    y: 309.4277,
    width: 26.656,
    height: 8.0776
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145.8092,
    y: 292.4647,
    width: 26.656,
    height: 8.0776
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145.8092,
    y: 275.5016,
    width: 26.656,
    height: 8.0777
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145.8092,
    y: 258.5385,
    width: 26.656,
    height: 8.0777
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 128.0382,
    y: 241.5756,
    width: 62.1979,
    height: 8.0776
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 128.0382,
    y: 224.6125,
    width: 62.1979,
    height: 8.0776
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.1216,343.3538v8.0777h65.429v0a33.7825,33.7825,0,0,0,21.9618-8.0775Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.1216,326.3908v8.0776h94.805a33.7192,33.7192,0,0,0,3.3665-8.0776Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 216.8926,
    y: 309.4277,
    width: 26.656,
    height: 8.0776
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.1111,292.4647H216.8926v8.0776H293.63A34.0569,34.0569,0,0,0,287.1111,292.4647Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.8926,275.5016v8.0777h70.51a34.0468,34.0468,0,0,0,6.5187-8.0777Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.2931,249.6532a33.7036,33.7036,0,0,0-3.3665-8.0776h-94.805v8.0776h98.1715Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.5124,232.69a33.7831,33.7831,0,0,0-21.9618-8.0776h-65.429V232.69h87.3908Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 216.8926,
    y: 258.5385,
    width: 26.656,
    height: 8.0777
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.5894,266.6162h28.8992a33.93,33.93,0,0,0,.9879-8.0777H268.5894Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.5894,309.4277v8.0776h29.8871a33.9294,33.9294,0,0,0-.9879-8.0776Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "355.828 224.569 305.746 224.569 305.746 232.646 358.63 232.646 355.828 224.569"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 305.7464,
    y: 343.3511,
    width: 44.4421,
    height: 8.0804
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 305.7464,
    y: 326.3821,
    width: 44.4421,
    height: 8.0804
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 323.523,
    y: 309.4134,
    width: 26.6656,
    height: 8.0804
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 323.523,
    y: 292.4444,
    width: 26.6656,
    height: 8.0804
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 403.5194,
    y: 343.3511,
    width: 44.4424,
    height: 8.0804
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 403.5194,
    y: 326.3821,
    width: 44.4424,
    height: 8.0804
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 403.5194,
    y: 309.4134,
    width: 26.6653,
    height: 8.0804
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 403.5194,
    y: 292.4444,
    width: 26.6653,
    height: 8.0804
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "403.519 283.556 430.185 283.556 430.185 275.476 403.519 275.476 380.203 275.476 377.399 283.556 400.802 283.556 403.519 275.86 403.519 283.556"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "373.505 275.476 350.189 275.476 323.523 275.476 323.523 283.556 350.189 283.556 350.189 275.86 352.905 283.556 376.309 283.556 373.505 275.476"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "430.185 258.507 386.089 258.507 383.286 266.587 430.185 266.587 430.185 258.507"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "397.863 224.569 395.06 232.649 447.962 232.649 447.962 224.569 397.863 224.569"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "376.837 351.431 379.691 343.351 374.016 343.351 376.837 351.431"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "370.878 334.463 382.829 334.463 385.682 326.382 368.026 326.382 370.878 334.463"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "364.887 317.494 388.821 317.494 391.673 309.413 362.035 309.413 364.887 317.494"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "358.897 300.525 394.811 300.525 397.664 292.444 356.044 292.444 358.897 300.525"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "323.523 266.587 370.422 266.587 367.618 258.507 323.523 258.507 323.523 266.587"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "389.173 249.618 447.962 249.618 447.962 241.538 391.976 241.538 389.173 249.618"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "361.732 241.538 305.746 241.538 305.746 249.618 364.535 249.618 361.732 241.538"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbm);
export default __webpack_public_path__ + "static/media/ibm.fb69a7751407a65d71f38e9dc5137426.svg";
export { ForwardRef as ReactComponent };